/** Parse brief fact paths like `contact.phones[0]`, `faqs[3].question`, `services.0.name`. */
export function parseBriefPathSegments(pathStr) {
  const segments = [];
  for (const part of String(pathStr || '').split('.')) {
    if (!part) continue;
    const bracket = /^([^[\]]+)\[(\d+)\]$/.exec(part);
    if (bracket) {
      segments.push(bracket[1], Number(bracket[2]));
      continue;
    }
    if (/^\d+$/.test(part)) {
      segments.push(Number(part));
      continue;
    }
    segments.push(part);
  }
  return segments;
}

export function getBriefPathValue(obj, pathStr) {
  const segments = parseBriefPathSegments(pathStr);
  if (segments.length === 0) return undefined;
  let cur = obj;
  for (const seg of segments) {
    if (cur == null || typeof cur !== 'object') return undefined;
    cur = cur[seg];
  }
  return cur;
}

export function setBriefPathValue(obj, pathStr, value) {
  const segments = parseBriefPathSegments(pathStr);
  if (segments.length === 0) return;
  let cur = obj;
  for (let i = 0; i < segments.length - 1; i += 1) {
    const seg = segments[i];
    const nextSeg = segments[i + 1];
    if (cur[seg] == null) {
      cur[seg] = typeof nextSeg === 'number' ? [] : {};
    }
    cur = cur[seg];
  }
  const last = segments[segments.length - 1];
  cur[last] = value;
}
